import { isEmpty, find } from 'lodash'
import moment from 'moment';

const initialState = {
    isFetchingPostData: false,
    isFetchingChildSupportAgreed: false,
    isFetchingChildSupportPayable: false,
    isFetchingChildSupportFactorPay: false,
    isFetchingChildSupportFactorRevised: false,
    isFetchingChildSupportFactor: false,
    isFetchingChildSupportFactorTax: false,
    isFetchingChildSupportParentPay: false,
    isFetchingChildSupportContOption: false,
    isFetchingChildSupportSpecialCircumstance: false,
    isFetchingChildSupportTimeShare: false,
    isFetchingChildSupportEqualCustody: false,
    isFetchingChildSupportChildMedicalOther: false,
    isFetchingChildSupportOtherSpecify: false,

    stipulation: {
        agreed: '-1',
        amount: 0
    },

    childSupportCalculate: {
        agreed: '-1',
        amount: 0
    },

    supportFactor: {
        agreed: '-1',
        amount: 0
    },

    unjustCase: {
        amount: '',
        date: ""

    },
    propertyTaxPay: {
        amount: ""
    },
    parentTaxPay: {
        amount: ""
    },
    ContOption: {
        whoIs : "-1",
        agreed: "0",    
    },
    circumstanceSpecial: {
        amount: ""
    },
    childTimeShare: {
        amount: -1
    },
    childEqualCustody: {
        amount: ""
    },
    childMedicalOpt : {
        agreed: '-1',
        amount: ""
    },
    otherOpt : {
        agreed: '-1',
        amount: ""
    }
    
}
const NonGuideLineReducer = (state = initialState, action) => {
    switch (action.type) {

        //1#
        case "REQUEST_POST_DATA":
            return { ...state, isFetchingPostData: true };
        case "SUCCESS_POST_DATA":
            return { ...state, isFetchingPostData: false };
        case "ERROR_POST_DATA":
            return { ...state, isFetchingPostData: false };

        //2#
        case "REQUEST_FL_342_CHILD_SUPPORT_AGREED":
            return { ...state, isFetchingChildSupportAgreed: true };
        case "SUCCESS_FL_342_CHILD_SUPPORT_AGREED":
            return {
                ...state, isFetchingChildSupportAgreed: false,
                stipulation: {
                    agreed: action.payload.stipulation,
                    amount: action.payload.stipulationFormulla
                }
            };
        case "ERROR_FL_342_CHILD_SUPPORT_AGREED":
            return { ...state, isFetchingChildSupportAgreed: false };

        //3#
        case "REQUEST_FL_342_CHILD_SUPPORT_PAYABLE":
            return { ...state, isFetchingChildSupportPayable: true };
        case "SUCCESS_FL_342_CHILD_SUPPORT_PAYABLE":
            return {
                ...state, isFetchingChildSupportPayable: false,
                childSupportCalculate: {
                    agreed: action.payload.childSupportCalculate,
                    amount: action.payload.supportPayable
                },
                supportFactor: {
                    agreed: action.payload.supportFactor,
                    amount: action.payload.supportAmount
                },
                unjustCase: {
                    amount: action.payload.unjustCase,
                    date: action.payload.untilDate
                },
                propertyTaxPay: {
                    amount: action.payload.propertytax
                },
                parentTaxPay: {
                    amount: action.payload.parentPay
                },
                ContOption :{
                    whoIs  :action.payload.whoIs,
                    agreed: action.payload.contributingOption
                },
                circumstanceSpecial :{
                    amount: action.payload.specialCircumstance
                },
                childTimeShare :{
                    amount: action.payload.timeShare
                },
                childEqualCustody:{
                    amount: action.payload.equalCustody
                },
                childMedicalOpt:{
                    agreed: action.payload.childSpecialMedical,
                    amount: action.payload.specialMedicalOtherDesc
                },
                otherOpt:{
                    agreed: action.payload.otherSpecifyId,
                    amount: action.payload.otherSpecify
                }
            };
        case "ERROR_FL_342_CHILD_SUPPORT_PAYABLE":
            return { ...state, isFetchingChildSupportPayable: false };   

        //14#
        case "REQUEST_FL_342_CHILD_SUPPORT_GET_ALL_DATA":
            return { ...state, isFetchingGetData: true };
        case "SUCCESS_FL_342_CHILD_SUPPORT_GET_ALL_DATA":
            return {
                 ...state, 
                stipulation: {
                    agreed: action.payload.data.stipulation.agreed,
                    amount: action.payload.data.stipulation.amount
                },
            
                childSupportCalculate: {
                    agreed: action.payload.data.childSupportCalculate.agreed,
                    amount: action.payload.data.childSupportCalculate.amount
                },
            
                supportFactor: {
                    agreed: action.payload.data.supportFactor.agreed,
                    amount: action.payload.data.supportFactor.amount
                },
            
                unjustCase: {
                    amount: action.payload.data.unjustCase.amount,
                    date: action.payload.data.unjustCase.date
            
                },
                propertyTaxPay: {
                    amount: action.payload.data.propertyTaxPay.amount
                },
                parentTaxPay: {
                    amount: action.payload.data.parentTaxPay.amount
                },
                ContOption: {
                    whoIs  :action.payload.data.ContOption.whoIs,
                    agreed: action.payload.data.ContOption.amount
                },
                circumstanceSpecial: {
                    amount: action.payload.data.circumstanceSpecial.amount
                },
                childTimeShare: {
                    amount:action.payload.data.childTimeShare.amount
                },
                childEqualCustody: {
                    amount: action.payload.data.childEqualCustody.amount
                },
                childMedicalOpt : {
                    agreed: action.payload.data.childMedicalOpt.agreed,
                    amount: action.payload.data.childMedicalOpt.amount
                },
                otherOpt : {
                    agreed: action.payload.data.otherOpt.agreed,
                    amount: action.payload.data.otherOpt.amount
                },
                
                isFetchingGetData: false };
        case "ERROR_FL_342_CHILD_SUPPORT_CHILD_GET_ALL_DATA":
            return { ...state, isFetchingGetData: false };

        default:
            return state;
    }
}


export default NonGuideLineReducer;